'use strict';

exports.__esModule = true;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styled = require('./styled');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Message = function Message(_ref) {
  var title = _ref.title,
      children = _ref.children,
      rest = _objectWithoutProperties(_ref, ['title', 'children']);

  return _react2.default.createElement(
    _styled.Message,
    rest,
    _react2.default.createElement(
      _styled.Title,
      null,
      _react2.default.createElement(
        'strong',
        null,
        title
      )
    ),
    _react2.default.createElement(
      _styled.Subtitle,
      null,
      children
    )
  );
};

Message.propTypes = process.env.NODE_ENV !== "production" ? {
  title: _propTypes2.default.string.isRequired,
  children: _propTypes2.default.node
} : {};

exports.default = Message;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/li-components/lib/Alert/Message.js
// module id = 2199
// module chunks = 14